import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import RegistrationForm from '../components/registration/RegistrationForm';
import PageLoader from '../components/common/PageLoader';
import { getEventDetails,trackQRScan } from '../services/api';

const Registration = () => {
    const { uuid } = useParams();
    const [eventDetails, setEventDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');


    useEffect(() => {
        fetchEventDetails();

        const queryParams = new URLSearchParams(location.search);
        const source = queryParams.get('utm_source');

        if (source === 'qr') {
            trackQRScan(uuid);
        }
    }, [uuid, location.search]);

    const fetchEventDetails = async () => {
        try {
            setLoading(true);
            const response = await getEventDetails(uuid);
            if (response.result) {
                setEventDetails(response.data);
                setError('');
            } else {
                setError('Unable to load event details. Please try again later.');
            }
        } catch (err) {
            console.error('Error fetching event details:', err);
            setError('Failed to load event details. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <PageLoader message="Loading event information..." />;
    }

    if (error) {
        return (
            <div className="error-container">
                <Header />
                <div className="container">
                    <div className="error-content">
                        <p>{error}</p>
                        <button className="button" onClick={fetchEventDetails}>
                            <i className="fa fa-refresh"></i> Try Again
                        </button>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    const heroStyle = {
        backgroundImage: eventDetails?.cover_image
            ? `url(${eventDetails.cover_image})`
            : 'linear-gradient(to right, #4CAF50, #2196F3)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    };

    return (
        <div className="registration-page">
            <Header />

            <div className="hero" style={heroStyle}>
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <h1 className="hero-title">
                        {eventDetails?.title || 'Event Registration'}
                    </h1>
                </div>
            </div>

            <div className="container">
                <RegistrationForm
                    uuid={uuid}
                    eventDetails={eventDetails}
                />
            </div>

            <Footer />
        </div>
    );
};

export default Registration;